import { ApplicationSidebar } from '@/components/molecules/applicantSidebar/ApplicantSidebar';
import { Flex, useDisclosure } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useParams } from 'react-router-dom';
import { AsideCollapse, SidebarCollapse } from 'shared-components';
import { ApplicationState } from '@/store';
import ApplicantLeftNav from '../../molecules/applicantLeftNav';
import { useApplicantDocuments } from '../../../hooks/useApplicantDocuments';
import { MainColumn } from '../../molecules/MainColumn';
import { useTranslation } from "react-i18next";

export default function ApplicantDashboard() {
    const { t } = useTranslation('common');
  // Get sidebar collapsed state from localStorage
  const { isOpen, onToggle } = useDisclosure({
    defaultIsOpen: JSON.parse(localStorage.getItem('sidebarIsOpen') || 'true'), // Default to true if not set
  });

  const { application } = useSelector((state: ApplicationState) => state.apply);
  const { familyName, givenName } = application;
  const params = useParams();
  const { userId, applicationId, uni } = params;

  // Preload all common document types to avoid duplicate API calls
  useApplicantDocuments();

  // Update localStorage whenever isOpen changes
  useEffect(() => {
    localStorage.setItem('sidebarIsOpen', JSON.stringify(isOpen));
  }, [isOpen]);

  return (
    <Flex ml={{ md: isOpen ? 'sidebarWidth' : 'sidebarCollapse' }} transition={'ease-out 0.3s margin-left'}>
      <SidebarCollapse
        label={t('common:applicantFileNavigation')}
        isOpen={isOpen}
        onToggle={onToggle}
        containerProps={{
          position: 'fixed',
          left: { base: 0, md: 'navbarWidth' },
          bottom: 0,
          top: 0,
          width: isOpen ? 'sidebarWidth' : 'sidebarCollapse',
          zIndex: 'docked',
        }}
      >
        <ApplicantLeftNav
          userId={userId}
          applicationId={applicationId}
          givenName={givenName}
          familyName={familyName}
          uni={uni}
        />
      </SidebarCollapse>

      <Flex
        flexGrow={1}
        flexDirection={{ base: 'column', lg: 'row' }}
        height={{ md: '100vh' }}
        overflow={{ md: 'hidden' }}
      >
        <MainColumn>
          <Outlet />
        </MainColumn>

        <AsideCollapse mobileProps={{ pt: 0 }}>
          <ApplicationSidebar />
        </AsideCollapse>
      </Flex>
    </Flex>
  );
}
